import TableCellRenderer from '../../../../table/TableCellRenderer'
import _ from 'underscore'
import $ from 'jquery'
import Switcher from '../../../../components/Switcher'

function BalanceControlRenderer () {}

BalanceControlRenderer.prototype = _.create(TableCellRenderer.prototype);

BalanceControlRenderer.prototype.init = function({
    onClickHandler = () => {},
    onMouseOverHandler = () => {},
    onMouseOutHandler = () => {}
}) {
    TableCellRenderer.call(this)
    this.onClickHandler = onClickHandler
    this.onMouseOverHandler = onMouseOverHandler
    this.onMouseOutHandler = onMouseOutHandler
    return this
}

BalanceControlRenderer.prototype.getCellClassName = function ( cell ) {
    var value = cell.getValue();
    return this.getFlagValue(value) ? [this.cellGeneralClassName, 'on'] : [this.cellGeneralClassName, 'off'];
};

BalanceControlRenderer.prototype.generateContent = function ( cell ) {
    var value = cell.getValue();
    var cellEl = cell.getCellEl();
    this.switcher = new Switcher({
        additionalClass: 'small',
        onSwitchCallback: (enabled) => {
            this.onClickHandler(cell, !this.getFlagValue(value))
        }
    }).init($(cellEl));
    this.switcher.setState({
        enabled: this.getFlagValue(value)
    })

    if (this.onClickHandler)
        cellEl.onclick = () => this.onClickHandler(cell, !this.getFlagValue(value))
    if (this.onMouseOverHandler)
        $(cellEl).hover(e => this.onMouseOverHandler(e), this.onMouseOutHandler)

    this.updateContent(cell)
}

BalanceControlRenderer.prototype.updateContent = function(cell) {
    this.switcher.setState({
        enabled: this.getFlagValue(cell.getValue())
    })
}

export default BalanceControlRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/BalanceControlRenderer.js